<template>
  <div id="sizeSlider">
    <div v-if="product == 'table' || product == 'bench'">
      <v-subheader class="pl-0">{{getText.length}}{{newLength}}cm</v-subheader>
      <br/>
      <v-slider
          :disabled="!individualDimensions"
          v-model="newLength"
          dense
          height="16"
          thumb-label="always"
          min="100"
          max="220"
          color="var(--mainColor)"
          thumb-color="var(--accentColor)"
          track-color="var(--mainColorShaded)"
        ></v-slider>
    </div>
    <div v-if="product == 'table'">
      <v-subheader class="pl-0">{{getText.width}}{{newWidth}}cm {{getText.numberOfPlanks1}} {{getNumberOfPlanks}} {{getText.numberOfPlanks2}}</v-subheader>
      <br/>
      <v-slider
          :disabled="!individualDimensions"
          v-model="newWidth"
          thumb-label="always"
          dense
          height="16"
          min="50"
          max="110"
          color="var(--mainColor)"
          thumb-color="var(--accentColor)"
          track-color="var(--mainColorShaded)"
        ></v-slider>
    </div>
    <div v-if="product == 'frame'">
      <v-subheader class="pl-0">{{getText.width}}{{newWidth}}cm</v-subheader>
      <br/>
      <v-slider
          v-model="newWidth"
          thumb-label="always"
          min="20"
          dense
          height="16"
          max="150"
          color="var(--mainColor)"
          thumb-color="var(--accentColor)"
          track-color="var(--mainColorShaded)"
        ></v-slider>
    </div>
    <div v-if="product == 'table' || product == 'stool'">
      <v-subheader class="pl-0">{{getText.height}}{{newHeight}}cm</v-subheader>
      <br/>
      <v-slider
          :disabled="!individualDimensions"
          v-if="product == 'table'"
          v-model="newHeight"
          thumb-label="always"
          min="45"
          dense
          height="16"
          max="100"
          color="var(--mainColor)"
          thumb-color="var(--accentColor)"
          track-color="var(--mainColorShaded)"
        ></v-slider>
        <v-slider
            :disabled="!individualDimensions"
            v-if="product == 'stool'"
            v-model="newHeight"
            thumb-label="always"
            min="45"
            dense
            height="16"
            max="85"
            color="var(--mainColor)"
            thumb-color="var(--accentColor)"
            track-color="var(--mainColorShaded)"
          ></v-slider>
    </div>
    <div v-if="product == 'frame'">
      <v-subheader class="pl-0">{{getText.height}}{{newHeight}}cm</v-subheader>
      <br/>
      <v-slider
          v-model="newHeight"
          thumb-label="always"
          min="20"
          dense
          height="16"
          max="150"
          color="var(--mainColor)"
          thumb-color="var(--accentColor)"
          track-color="var(--mainColorShaded)"
        ></v-slider>
    </div>
  </div>
</template>

<script>

export default {
  name: 'configuratorDesktopSize',
  props: ['product'],
  data() {
    return{
      newLength: 0,
      newWidth: 0,
      newHeight: 0,
    }
   },
   components: {
     },
   computed: {
     getText(){
       return this.$store.getters.getText.configurator.dimensions
     },
     individualDimensions(){
       var returnVal= false
       switch(this.product){
         case 'table':
           if(this.$store.getters.getTableConfig.dimensions.chosen == 'individual'){
             returnVal = true
           } else {
             returnVal = false
           }
         break;
         case 'bench':
           if(this.$store.getters.getBenchConfig.dimensions.chosen == 'individual'){
             returnVal = true
           } else {
             returnVal = false
           }
         break;
         case 'stool':
           if(this.$store.getters.getStoolConfig.dimensions.chosen == 'individual'){
             returnVal = true
           } else {
             returnVal = false
           }
         break;
         default:
         break;
       }
       return returnVal
     },
     getTableLength() {
       return this.$store.getters.getTableConfig.dimensions.length;
     },
     getTableWidth() {
       return this.$store.getters.getTableConfig.dimensions.width;
     },
     getTableHeight() {
       return this.$store.getters.getTableConfig.dimensions.height;
     },
     getFrameWidth() {
       return this.$store.getters.getFrameConfig.dimensions.width;
     },
     getFrameHeight() {
       return this.$store.getters.getFrameConfig.dimensions.height;
     },
     getBenchLength() {
       return this.$store.getters.getBenchConfig.dimensions.length;
     },
     getStoolHeight() {
       return this.$store.getters.getStoolConfig.dimensions.height;
     },
     getNumberOfPlanks() {
       return this.$store.getters.getTableConfig.planks.numberOfPlanks;
     }
   },
   methods: {
     updateSlider(){
       switch(this.product){
         case 'table':
           this.newLength = this.getTableLength
           this.newWidth = this.getTableWidth
           this.newHeight = this.getTableHeight
           this.$store.dispatch("checkTableActivePlanks");
         break;
         case 'frame':
           this.newWidth = this.getFrameWidth
           this.newHeight = this.getFrameHeight
         break;
         case 'bench':
           this.newLength = this.getBenchLength
         break
         case 'stool':
           this.newHeight = this.getStoolHeight
         break
         default:
         break;
       }
     },
   },
   mounted (){
     this.updateSlider()
   },
   watch: {
     getTableLength(){
       this.updateSlider()
     },
     getTableWidth(){
       this.updateSlider()
     },
     getFrameWidth(){
       this.updateSlider()
     },
     getTableHeight(){
       this.updateSlider()
     },
     getFrameHeight(){
       this.updateSlider()
     },
     getBenchLength(){
       this.updateSlider()
     },
     getStoolHeight(){
       this.updateSlider()
     },
     newLength: function() {
       switch(this.product){
         case 'table':
           this.$store.dispatch("changeTableConfig", {change: 'length', value: Number(this.newLength)});
         break
         case 'bench':
           this.$store.dispatch("changeBenchConfig", {change: 'length', value: Number(this.newLength)});
         break
         default:
         break
       }
     },
     newWidth: function() {
       switch (this.product){
       case 'table':
         this.$store.dispatch("changeTableConfig", {change: 'width', value: Number(this.newWidth)});
         break;
       case 'frame':
         this.$store.dispatch("changeFrameConfig", {change: 'width', value: Number(this.newWidth)});
         break;
       default:
         break;
       }
     },
     newHeight: function() {
       switch(this.product){
         case 'table':
           this.$store.dispatch("changeTableConfig", {change: 'height', value: Number(this.newHeight)});
         break
         case 'frame':
           this.$store.dispatch("changeFrameConfig", {change: 'height', value: Number(this.newHeight)});
         break
         case 'stool':
           this.$store.dispatch("changeStoolConfig", {change: 'height', value: Number(this.newHeight)});
         break
         default:
         break
       }
     },
   },
}
</script>

<style scoped>
  #sizeSlider {
    position: relative;
    top: -15px;
  }
  #sizeSlider{
    display: grid;
    grid-template-rows: 1fr 1fr 1fr;
  }
  .v-messages .theme--light{
    height: 0 !important;
  }

</style>
